import { SnackbarList } from "@wordpress/components";
import { useSelect, useDispatch } from "@wordpress/data";
import { store as noticesStore } from "@wordpress/notices";
import { useEffect } from "react";

const Notices = () => {
  const notices = useSelect((select) => select(noticesStore).getNotices(), []);
  const { removeNotice } = useDispatch(noticesStore);

  const snackbarNotices = notices.filter(
    (notice) => notice.type === "snackbar"
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (snackbarNotices.length > 0) {
        removeNotice(snackbarNotices[0].id);
      }
    }, 2500); // 3 seconds

    return () => clearTimeout(timeout);
  }, [snackbarNotices, removeNotice]);

  return (
    <SnackbarList
      notices={snackbarNotices}
      className="components-editor-notices__snackbar"
      onRemove={removeNotice}
    />
  );
};

export default Notices;
